import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHome16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconHome16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m8 .892.285.197 6.5 4.5a.5.5 0 1 1-.57.822L14 6.262V12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6.262l-.215.15a.5.5 0 1 1-.57-.823l6.5-4.5zm0 1.216 5 3.462V12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5.57zm-1.972 6.12c-.069-.323-.025-.61.264-.928.212-.233.354-.281.407-.293a.32.32 0 0 1 .195.022.94.94 0 0 1 .332.232l.011.012a1 1 0 0 0 1.537-.012 1.1 1.1 0 0 1 .332-.232.32.32 0 0 1 .195-.022c.053.012.195.06.407.293.29.318.333.605.264.928-.083.384-.34.837-.732 1.311a9 9 0 0 1-1.198 1.173L8 10.746l-.042-.034A9 9 0 0 1 6.76 9.54c-.392-.474-.65-.927-.732-1.311M8 6.626s.185-.224.49-.405c.458-.27 1.186-.441 1.957.405C12.544 8.93 8 12 8 12S3.456 8.93 5.553 6.626c.771-.846 1.499-.676 1.957-.405.305.18.49.405.49.405"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHome16);
